import EmojiField from "./EmojiField"

export default EmojiField
